import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormDefinition } from '../form-definition';
import { FieldDefinition } from '../field-definition';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: false
})
export class FormComponent {

  @Input()
  formElId: string;

  @Input()
  form: FormDefinition;

  @Output()
  fieldChange = new EventEmitter<FieldDefinition>();

  onBlurField(evt: FocusEvent): void {
    const trgt = evt.target as HTMLInputElement;
    if (trgt.checkValidity()) {
      trgt.classList.remove('govuk-input--error');
      const container = document.getElementById(trgt.id).closest('.govuk-form-group');
      container.classList.remove('govuk-form-group--error');
      if (container.querySelector('.govuk-error-message'))
        container.querySelector('.govuk-error-message').classList.add('govuk-visually-hidden');
      // console.info(' saving: '+val+' to '+trgt.id+' of '+task.id);
      const field = this.form.fields.find(f => f.id === trgt.id);
      if (evt.target['type'] === 'checkbox') field.value = trgt.checked;
      // this.fieldChange.emit(field);
    } else {
      trgt.classList.add('govuk-input--error');
      const container = document.getElementById(trgt.id).closest('.govuk-form-group');
      container.classList.add('govuk-form-group--error');
      if (container.querySelector('.govuk-visually-hidden'))
        container.querySelector('.govuk-visually-hidden').classList.remove('govuk-visually-hidden');
      container.querySelector('.govuk-error-message').innerHTML = trgt.validationMessage;
    }
  }
}
